import {
	IPosSystemType,
	IAdditionalApplicationsType,
	IWatchesCommandsType,
	RestaurantNotificationEventType,
	ISoftwareType,
	IReportType,
	IScheduleType,
	TTypeOfSchedule,
	TYandexPaymentType,
	ITlsCertificateLevelType,
	NfcCardPermission,
} from 'types';

export const posSystemTypes: IPosSystemType[] = [
	{ posSystemID: 1, posSystemName: 'Iiko' },
	{ posSystemID: 2, posSystemName: 'Rkeeper' },
	{ posSystemID: 3, posSystemName: 'Servio' },
	{ posSystemID: 4, posSystemName: 'Untill' },
	{ posSystemID: 5, posSystemName: 'Stable' },
	{ posSystemID: 6, posSystemName: 'Hypersoft' },
	{ posSystemID: 7, posSystemName: 'RkeeperFastFood' },
	{ posSystemID: 8, posSystemName: 'Aloha' },
	{ posSystemID: 9, posSystemName: 'Micros' },
	{ posSystemID: 10, posSystemName: 'Access' },
	{ posSystemID: 11, posSystemName: '3Spos' },
	{ posSystemID: 12, posSystemName: 'Deliverect' },
	{ posSystemID: 13, posSystemName: 'Dotykacka' },
	{ posSystemID: 14, posSystemName: 'Zonal' },
	{ posSystemID: 15, posSystemName: 'Square' },
	{ posSystemID: 16, posSystemName: 'Flipdish' },
	{ posSystemID: 17, posSystemName: 'Foodhub' },
	{ posSystemID: 18, posSystemName: 'Notepos' },
];

export const additionalApplications: IAdditionalApplicationsType[] = [
	{ additionalApplicationID: 'VivaWallet', additionalApplicationName: 'VivaWallet' },
	{ additionalApplicationID: 'M4', additionalApplicationName: 'M4 Bank' },
	{ additionalApplicationID: 'TBank', additionalApplicationName: 'TBank' },
	{ additionalApplicationID: 'Toucan', additionalApplicationName: '2Can' },
];

export const watchesCommandsTypes: IWatchesCommandsType[] = [
	{ id: 'BatteryOverheated', name: 'BatteryOverheated', disabled: true },
	{ id: 'CallWaiter', name: 'CallWaiter', disabled: false },
	{ id: 'CreateOrder', name: 'CreateOrder', disabled: false },
	{ id: 'OrderPaid', name: 'OrderPaid', disabled: false },
	{ id: 'Error', name: 'Error', disabled: false },
	{ id: 'AlcoholVerification', name: 'AlcoholVerification', disabled: false },
];

export const restaurantNotificationEvents: RestaurantNotificationEventType[] = [
	RestaurantNotificationEventType.PushUpdateAllSettings,
	RestaurantNotificationEventType.PushUpdateMainSettings,
	RestaurantNotificationEventType.PushUpdateGames,
	RestaurantNotificationEventType.PushUpdateConfigurationFile,
	RestaurantNotificationEventType.PushUpdateRestaurantSettings,
	RestaurantNotificationEventType.PushUpdateRestaurantMenu,
	RestaurantNotificationEventType.PushCloseDay,
	RestaurantNotificationEventType.PushRestartApp,
	RestaurantNotificationEventType.PushDownloadFirmware,
	RestaurantNotificationEventType.PushUpdateLauncherConfig,
	RestaurantNotificationEventType.PushRebootDevices,
	RestaurantNotificationEventType.PushShutdownDevices,
	RestaurantNotificationEventType.PushPriceUpdate,
	RestaurantNotificationEventType.PushUpdateEncryptedPaymentConfig,
	RestaurantNotificationEventType.PushUpdateTeasers,
	RestaurantNotificationEventType.PushUpdateVideos,
	RestaurantNotificationEventType.PushDmsNetworkParams,
	RestaurantNotificationEventType.SynchronizationMenu,
	RestaurantNotificationEventType.SyncRestaurantMenu,
	RestaurantNotificationEventType.PushRestaurantMenu,
];

export const availablePushScheduleForClientManager: RestaurantNotificationEventType[] = [
	RestaurantNotificationEventType.PushUpdateAllSettings,
	RestaurantNotificationEventType.PushUpdateMainSettings,
	RestaurantNotificationEventType.PushUpdateTeasers,
	RestaurantNotificationEventType.PushUpdateConfigurationFile,
	RestaurantNotificationEventType.PushUpdateRestaurantSettings,
	RestaurantNotificationEventType.PushUpdateRestaurantMenu,
	RestaurantNotificationEventType.PushCloseDay,
	RestaurantNotificationEventType.PushRebootDevices,
	RestaurantNotificationEventType.PushShutdownDevices,
	RestaurantNotificationEventType.PushPriceUpdate,
	RestaurantNotificationEventType.SynchronizationMenu,
	RestaurantNotificationEventType.SyncRestaurantMenu,
	RestaurantNotificationEventType.PushRestaurantMenu,
];

export const availablePushScheduleForRestaurantManager: RestaurantNotificationEventType[] = [
	RestaurantNotificationEventType.PushUpdateMainSettings,
	RestaurantNotificationEventType.PushUpdateRestaurantMenu,
	RestaurantNotificationEventType.PushUpdateTeasers,
	RestaurantNotificationEventType.PushUpdateRestaurantSettings,
	RestaurantNotificationEventType.PushPriceUpdate,
	RestaurantNotificationEventType.SynchronizationMenu,
	RestaurantNotificationEventType.SyncRestaurantMenu,
	RestaurantNotificationEventType.PushRestaurantMenu,
];

export const forceReloadPushEvents: RestaurantNotificationEventType[] = [
	RestaurantNotificationEventType.PushUpdateAllSettings,
	RestaurantNotificationEventType.PushUpdateRestaurantSettings,
	RestaurantNotificationEventType.PushUpdateMainSettings,
	RestaurantNotificationEventType.PushUpdateTeasers,
	RestaurantNotificationEventType.PushUpdateGames,
	RestaurantNotificationEventType.PushUpdateVideos,
	RestaurantNotificationEventType.PushUpdateRestaurantMenu,
	RestaurantNotificationEventType.PushRestaurantMenu,
	RestaurantNotificationEventType.PushUpdateEncryptedPaymentConfig,
];

export const softwareTypes: ISoftwareType[] = [
	{ id: 1, name: 'Firmware' },
	{ id: 2, name: 'TabletApp' },
];

export const reportType: IReportType[] = [
	{ reportTypeID: 'Detailed', reportTypeName: 'reportTypeDetailed' },
	{ reportTypeID: 'OrderWithError', reportTypeName: 'reportTypeOrderWithError' },
	{ reportTypeID: 'Fees', reportTypeName: 'reportTypeFees' },
	{ reportTypeID: 'Period', reportTypeName: 'reportTypePeriod' }, // is not use now
	{ reportTypeID: 'OrderTips', reportTypeName: 'reportTypeOrderTips' }, // is not use now
	{ reportTypeID: 'TermsAndConditions', reportTypeName: 'reportTypeTermsAndConditions' }, // is not use now
];

export const scheduleType: IScheduleType[] = [
	{ scheduleTypeID: 'Daily', scheduleTypeName: 'scheduleTypeDaily' },
	{ scheduleTypeID: 'Weekly', scheduleTypeName: 'scheduleTypeWeekly' },
	{ scheduleTypeID: 'Monthly', scheduleTypeName: 'scheduleTypeMonthly' },
];

export const availableScheduleTypesForFeesReport: TTypeOfSchedule[] = ['Weekly', 'Monthly'];

export const RSB_SBP_QR_BANK_SETTINGS_ID = 'b5e8dfb4-916b-4d13-a830-7fbf9712308a';
export const YANDEX_PAY_QR_BANK_SETTINGS_ID = 'fe79cb97-d0be-4286-9bb0-4175aa1a052b';
export const VIVA_WALLET_SOFT_POS_QR_BANK_SETTINGS_ID = '4cec80b1-89be-4a07-a1b0-6f3290ef5cdc';
export const BEST_2_PAY_QR_BANK_SETTINGS_ID = '59d2c7a6-1dfd-4b13-8dd4-2d459b7a7187';
export const YANDEX_CHECK_QR_BANK_SETTINGS_ID = '00587bca-48ab-489b-9e54-1f242dc61151';
export const ADYEN_BANK_SETTINGS_ID = '6d91cb21-98a5-4e5b-acf8-69b003894f89';
export const TOUCAN_BANK_SETTINGS_ID = '6ccef41c-09e2-4e68-897c-1a2a27cd3360';
export const TOUCAN_SBP_QR_BANK_SETTINGS_ID = '7d9f8a2e-5c1b-4e3a-9f8d-2e1a3b4c5d6e';
export const TBANK_BANK_SETTINGS_ID = 'da2f7bc6-4d46-42f2-b611-a27ebf72feaa';

export const yandexPaymentTypes: { id: TYandexPaymentType; name: TYandexPaymentType }[] = [
	{ id: 'Split', name: 'Split' },
	{ id: 'Card', name: 'Card' },
];

export const tlsCertificateLevel: ITlsCertificateLevelType[] = [
	{ id: 'Restaurant', name: 'useCertificateOnRestaurantLevelForAllDevices' },
	{ id: 'Device', name: 'useCertificateForDevicesIndividually' },
];

export const nfcCardPermission = [
	{ id: NfcCardPermission.None, name: 'none' },
	{ id: NfcCardPermission.UnlockOrderPayment, name: 'confirmOrderPayment' },
];
